export const ORIGIN: string = process.env.ORIGIN;
